import React, { useContext } from 'react';

import * as watchUtils from "@arcgis/core/core/watchUtils";

import ElementoListaResumen from './listaResumenElemento';
import { CodigosListaListaResumenNoCargada, TiposListaResumen } from '../../utils/enums';
import { addManyGraphicsListaResumen, getLayerViewGeometriesByIds, getLayerViewOfLayer } from '../../utils/mapaUtils';
import RefsContext from '../../contexts/RefsContext';
import { ElementoListaResumenCapaGraphic } from '../../classes/reducerClasses';
import { clickContainerExpandIfMovilVerticalAndPopupVisible } from '../../utils/widgetsUtils';

function ListaResumen({ listaResumen, maximoItems, tipoListaResumen }) {
    const { mapViewRef, expandsWidgetsButtonsRef } = useContext(RefsContext);

    function seleccionarElementosGraphics(layerView, ids){
        getLayerViewGeometriesByIds(mapViewRef.current, layerView, ids).then(graphics => {
            addManyGraphicsListaResumen(mapViewRef.current, graphics, tipoListaResumen)
        });
    }
    function getArrayOfElementoGrupo(elementoGrupo, property){
        return listaResumen.lista.reduce((previousValue, currentValue, currentIndex) => {
            if (currentIndex >= elementoGrupo.indexIni && currentIndex <= elementoGrupo.indexFin){
                previousValue.push(currentValue[property]);
            }
            return previousValue;
        }, []);
    }
    function seleccionarElementosGrupo(elementoGrupo){
        addManyGraphicsListaResumen(mapViewRef.current, getArrayOfElementoGrupo(elementoGrupo, ElementoListaResumenCapaGraphic.propGraphic), tipoListaResumen);
    }
    function irToElementosGrupo(elementoGrupo){
        if (tipoListaResumen === TiposListaResumen.cerca){
            clickContainerExpandIfMovilVerticalAndPopupVisible(mapViewRef.current, expandsWidgetsButtonsRef.current.expands.cerca);
        }
        const graphics = getArrayOfElementoGrupo(elementoGrupo, ElementoListaResumenCapaGraphic.propGraphic);
        graphics.forEach(x => {
            x.popupTemplate = x.layer.popupTemplate;
        })
        mapViewRef.current.goTo(graphics).then(()=>{
            mapViewRef.current.popup.open({ features: graphics });
            seleccionarElementosGrupo(elementoGrupo);
            if (graphics.length === 1){
                if (graphics[0].geometry.type === "point" && listaResumen.zoomParaPunto){
                    mapViewRef.current.zoom = listaResumen.zoomParaPunto;
                }
            } else { // graphics.length > 1 (graphics siempre viene con elementos)
                if (graphics[0].geometry.type !== "point") {
                    const idsRegistros = getArrayOfElementoGrupo(elementoGrupo, ElementoListaResumenCapaGraphic.propIdRegistro);
                    const layerView = getLayerViewOfLayer(mapViewRef.current, listaResumen.idLayer) 
                    if (layerView.updating){
                        watchUtils.whenFalseOnce(layerView, "updating", () => {
                            seleccionarElementosGraphics(layerView, idsRegistros);
                        })
                    } else {
                        seleccionarElementosGraphics(layerView, idsRegistros);
                    }
                }
            }
        }); 
    }

    if (!listaResumen){
        return null;
    } else  if (!listaResumen.lista){
        return (
            <div className='avisosLista blink'>
                Generando lista...
            </div>
        )
    } else if (listaResumen.lista === CodigosListaListaResumenNoCargada.max){
        //Sólo aplicaba para ListaResumen de LayerList (TiposListaResumen.layerList)
        //CodigosListaListaResumenNoCargada.max se asigna en mapa.js -> Clase MapaMaster -> #setLayerListReferences
        return (
            <div className='avisosLista'>
                {`Puedes ver el detalle de máximo ${maximoItems} registros.`}
            </div>
        )
    } else if (listaResumen.lista === CodigosListaListaResumenNoCargada.errorAlCargar){
        return (
            <div className='avisosLista'>
                Error al cargar la lista
            </div>
        )
    } else if (listaResumen.lista.length === 0){
        return (
            //Actualmente sólo aplicaba para TiposListaResumen.layerList, se deja la validación de tipoListaResumen en caso de que cambie el comportamiento en algún momento
            //Ojo en esta implementación para cualquier otro tipo de TiposListaResumen saldría "No se encontraron registros", en caso de que no se controle de otra forma en el lugar donde se use
            <div className='avisosLista'>
                {tipoListaResumen === TiposListaResumen.layerList ? "No hay elementos en la escala actual" : "No se encontraron registros"} 
            </div>
        )
    } else {
        return (
            <table className='tablaLista' width="100%" style={{overflowY: "scroll"}}>
                <tbody>
                    {
                        listaResumen.lista.map((elementoListaResumen, index) =>
                            <ElementoListaResumen
                                key={`${tipoListaResumen}_${listaResumen.idLayer}_${index}`}
                                conAgrupacion={listaResumen.campoAgrupacion ? true : false}
                                elementoListaResumen={elementoListaResumen}
                                indexElemento={index}
                                zoomParaPunto={listaResumen.zoomParaPunto}
                                tipoListaResumen={tipoListaResumen}
                                seleccionarElementosGrupo={seleccionarElementosGrupo}
                                irToElementosGrupo={irToElementosGrupo}
                                >
                            </ElementoListaResumen>)
                    }
                </tbody>
            </table>
        )
    }
}

export default ListaResumen;